import React from 'react'
import Button from 'core/elements/button'
import ExternalLink from 'core/components/ExternalLink'
import generateTestId from 'utils/test-helpers'

export default function LinkButton({ children, url, ...rest }) {
  return (
    <ExternalLink url={url}>
      <Button
        data-testid={generateTestId(children)}
        variant="secondary"
        icon="arrow-up-right-from-square"
        {...rest}
      >
        {children}
      </Button>
    </ExternalLink>
  )
}
